module.exports = __webpack_public_path__ + "img/vector-x.69b72226.svg";